import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  ScreenContainer,
} from '../../CommonComponents';
import ProductsTable from './ProductsTable';
import {
  createDashUser, showUserForm,
} from '../../redux/actions/dashusers';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';

const AssignProducts = () => {
  const [client, setClient] = useState(null)

  return (
    <ScreenContainer title="Assign Products">
      <PrimaryFilters
        selectedValue={setClient}
      />
      <br />
      <br />
      {client
        ? <ProductsTable client={client} />
        : <FallbackCard text="No data found" />}
    </ScreenContainer>
  );
}

const mapActions = {
  createDUser: createDashUser,
  showForm: showUserForm,
};

export default connect(null, mapActions)(AssignProducts);
